export default {
    route: null,
    stateId: null,
    token: null,
    RAZORPAY_KEY: 'ECOM_RAZORPAY_KEY',
    VERSION: '0.1.2'
}